import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { PaginatedResponse } from "@/shared/http";

import { AgentRecord } from "../AgentRecord";

export interface UseAgentsOptions {
  orgId?: string;
  pageToken?: string;
  limit?: number;
}

/**
 * Paginated list of agents in the caller's org. Backs the Agents tab.
 */
export function useAgents(
  options?: UseAgentsOptions,
): UseQueryResult<PaginatedResponse<AgentRecord>, Error> {
  const { agentService } = useDomainServices();

  return useQuery<PaginatedResponse<AgentRecord>, Error>({
    queryKey: ["agents", options?.orgId, options?.pageToken, options?.limit],
    queryFn: ({ signal }) => {
      return agentService.listAgents({
        orgId: options?.orgId,
        pageToken: options?.pageToken,
        limit: options?.limit,
        abortSignal: signal,
      });
    },
    enabled: options?.orgId !== undefined,
    staleTime: 30_000,
  });
}
